/* eslint-disable react/prop-types */
import React from 'react';
import { FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';

export function bsValidationState(touched = false, error) {
  if (!touched) { return null; }
  return error ? 'error' : 'success';
}

export function renderFormField({
  /* formField */
  field: {
    name,
    placeholder,
    label,
    type,
    isRequired,
  },
  /* formProps */
  formProps: {
    values,
    touched,
    handleChange,
    handleBlur,
    errors,
  },
  formGroupProps = {},
  formControlProps = {},
}) {
  return (
    <FormGroup
      key={name}
      controlId={name}
      validationState={bsValidationState(touched[name], errors[name])}
      {...formGroupProps}
    >
      <ControlLabel>
        {label}
        {isRequired && ' (Obrigatório)'}
      </ControlLabel>
      <FormControl
        type={type || 'text'}
        value={values[name]}
        placeholder={placeholder === true ? label : placeholder}
        onChange={handleChange}
        onBlur={handleBlur}
        {...formControlProps}
      />
      <FormControl.Feedback />
      {touched[name] && errors[name] && <HelpBlock><small>{errors[name]}</small></HelpBlock>}
    </FormGroup>
  );
}



// WEBPACK FOOTER //
// ./src/helpers/forms.js